module.exports = __webpack_public_path__ + "img/banner.23611252.png";